
import { css } from 'lit';
export default css`
:host{
  --wysiwyg-font-color:var(--neutral-charcoal);
  --wysiwyg-font-color-h5:var(--neutral-charcoal);
  --wysiwyg-font-weight-h5:var(--fw-semibold);
  --wysiwyg-font-height-h5:140%;
  display:block;
}

.accordion-content{
  visibility:hidden;
  visibility:var(--accordion-content-visibility, hidden);
  opacity:0;
  opacity:var(--accordion-content-opacity, 0);
  box-sizing:border-box;
  height:0;
  height:var(--accordion-content-print, 0);
  transition:all 300ms ease-in-out;
}

:host([is-ready]) .accordion-content{
    visibility:visible;
    visibility:var(--accordion-content-visibility, visible);
    opacity:1;
    opacity:var(--accordion-content-opacity, 1);
    height:var(--accordion-content-height);
  }

.accordion-content.preview{
  visibility:visible;
  opacity:1;
  height:auto;
}

.content{
  padding-right:var(--spacing-2);
  padding-bottom:var(--spacing-5);
  padding-left:var(--spacing-2);
}

@media print{

.content{
    padding-left:var(--spacing-0)
}
  }

@media (min-width: 992px){

.content{
    padding-bottom:var(--spacing-6)
}
  }
`;